import { TestsConfig } from './abTests.types';

const LEGACY_TESTS = {
  // OLD TESTS:
  // export const EXPENSIVE_PLANS_TEST = 'expensive_plans_test';
  // export const CHEAP_MONTHLY_PLAN_TEST = 'cheap_monthly_plan_test';
  // export const FREE_DELETES_TEST = 'free_deletes_test';
  // export const HIDE_TOTAL_DUE_TEST = 'hide_total_due_test';
  // export const HIDE_DELETE_TAB = 'hide_delete_tab';
  // export const SHOW_FREE_UNSUBSCRIBES_REMAINING = 'show_free_unsubscribes_remaining';
  // export const DIRECT_LOGIN_TEST = 'direct_login_test';
  // export const DIRECT_LOGIN_TEST_2 = 'direct_login_test_2';
  // export const CHURN_WINBACK_TEST = 'churn_winback_test';
  // export const CHURN_WINBACK_TEST_2 = 'churn_winback_test_2';
  // export const CHURN_WINBACK_TEST_3 = 'churn_winback_test_3';
  // export const SOLID_BUTTONS_TEST = 'solid_buttons_test';
  DISABLE_UNINSTALL_SURVEY_LIFETIME_DISCOUNT: 'disable_uninstall_survey_lifetime_discount_test',
};

export const ACTIVE_TESTS = {
  // Pending tests:
  HARD_ANNUAL_ONLY_TRIAL_PAYWALL: 'hard_annual_only_trial_paywall_2',
  CHEAP_OFFERING: 'cheap_offering',
};

const PLANNED_TESTS = {
  PRICE_TEST_LIFETIME_PLAN: 'price_test_lifetime_plan_web',
  WEB_2_APP_FUNNEL_SLIDESHOW: 'web_2_app_funnel_slideshow',
};

export const AB_TESTS = {
  ...LEGACY_TESTS,
  ...ACTIVE_TESTS,
  ...PLANNED_TESTS,
};

export const TEST_CONFIG: TestsConfig = {
  tests: [],
  controlGroupAllocation: 1,
};
